module.exports = __webpack_public_path__ + "static/media/heroVideo.3b04884b.mov";